import { useQuery } from '@tanstack/react-query';
import { getGames } from '../services/api';

export const useGames = () => {
  const {
    data: games = [],
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['games'],
    queryFn: getGames,
  });

  return {
    games,
    isLoading,
    isError,
    error,
    refetch,
  };
};
